import React from 'react'
import PropTypes from 'prop-types'
import { kebabCase } from 'lodash'
import { Helmet } from 'react-helmet'
import { graphql, Link } from 'gatsby'

import Layout from '../components/Layout'
import Content, { HTMLContent } from '../components/Content'
import SEO from '../components/Seo'

export const BlogPostTemplate = ({
  content,
  contentComponent,
  description,
  tags,
  title,
  helmet,
  date,
  author,
}) => {
  const PostContent = contentComponent || Content

  return (
    <section className='section blog page-padding section-padding'>
      {helmet || ''}
      <div
        className='container is-max-widescreen'
        style={{ padding: '0 2rem 6rem' }}
      >
        <div className='container content'>
          <div className='columns' style={{ margin: '0' }}>
            <div className='column is-8 is-offset-2' style={{ padding: '0' }}>
              <span className='is-block is-uppercase orange-text'>
                {date} x {author}
              </span>
              <h1 className='title has-text-weight-bold is-bold-light blog-header'>
                {title}
              </h1>
              <p className='blog-subheading'>{description}</p>
              <PostContent content={content} />
              {tags && tags.length ? (
                <div style={{ marginTop: `4rem` }}>
                  <h4>Tags</h4>
                  <ul className='taglist'>
                    {tags.map((tag) => (
                      <li key={tag + `tag`}>
                        <Link to={`/tags/${kebabCase(tag)}/`}>{tag}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

BlogPostTemplate.propTypes = {
  content: PropTypes.node.isRequired,
  contentComponent: PropTypes.func,
  description: PropTypes.string,
  title: PropTypes.string,
  helmet: PropTypes.object,
  date: PropTypes.string,
  author: PropTypes.string,
}

const BlogPost = ({ data }) => {
  const { markdownRemark: post } = data
  return (
    <Layout>
      {!!post.frontmatter.seo && (
        <SEO
          title={post.frontmatter.seo.title || null}
          description={post.frontmatter.seo.description || 'Blog'}
          image={post.frontmatter.seo.image || null}
          pathname={post.frontmatter.seo.slug || null}
          article={true}
        />
      )}
      <BlogPostTemplate
        content={post.html}
        contentComponent={HTMLContent}
        description={post.frontmatter.description}
        helmet={
          <Helmet>
            <body className='menu-color-2' />
          </Helmet>
        }
        tags={post.frontmatter.tags}
        title={post.frontmatter.title}
        date={post.frontmatter.date}
        author={post.frontmatter.author}
      />
    </Layout>
  )
}

BlogPost.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
}

export default BlogPost

export const pageQuery = graphql`
  query BlogPostByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        title
        description
        tags
        author
        seo {
          title
          description
          image {
            name
          }
        }
      }
    }
  }
`
